import React from "react";
import { NavbarData } from "../Navbar/NavbarData";
import { NavLink } from "react-router-dom";
import { Tooltip } from "primereact/tooltip";

const BottomNavigation = () => {
  return (
    <div className="flex justify-center lg:fixed bottom-2 right-1/4 overflow-hidden  md:rounded-3xl">
      <div className="w-full h-[8vh]  bg-primary-color lg:w-fit ">
        <ul className="flex h-full bg-blue-7 overflow-x-scroll p-0  gap-2 text-white">
          {NavbarData.map((item) => (
            // <div className="bg-red-800 h-full">{item.icon}</div>
            <li className="h-full" key={item.name}>
              <NavLink
                title={item.name}
                to={item.url}
                className="min-w-[100px] h-full p-0  flex justify-center items-center transition-all duration-300 ease-in-out"
                style={({ isActive }) => {
                  return isActive
                    ? {
                        backgroundColor: "rgb(33, 150, 243)",
                      }
                    : {};
                }}
                target={item.target}
              >
                <span
                  className={
                    item.name.toLowerCase().split(" ").join("-") +
                    " hidden lg:block"
                  }
                >
                  {item.icon}
                </span>
                <span className="lg:hidden "> {item.name}</span>
              </NavLink>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default BottomNavigation;
